import { render } from "./initialConsultation.vue?vue&type=template&id=168aa89a&scoped=true"
import script from "./initialConsultation.vue?vue&type=script&lang=js"
export * from "./initialConsultation.vue?vue&type=script&lang=js"

import "./initialConsultation.vue?vue&type=style&index=0&id=168aa89a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168aa89a"]])

export default __exports__